export const AuthStrategy = {
  AUTH0: 'AUTH0',
  CUSTOM: 'CUSTOM',
} as const;
